module.exports = __webpack_public_path__ + "img/percent.8791eb7d.svg";